import script from "./RegistError.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegistError.vue?vue&type=script&lang=ts&setup=true"

import "./RegistError.vue?vue&type=style&index=0&id=3f0bb04a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0bb04a"]])

export default __exports__